import { render, staticRenderFns } from "./FormAIcodeAccordion.vue?vue&type=template&id=1bd2f45c&scoped=true"
import script from "./FormAIcodeAccordion.vue?vue&type=script&lang=js"
export * from "./FormAIcodeAccordion.vue?vue&type=script&lang=js"
import style0 from "./FormAIcodeAccordion.vue?vue&type=style&index=0&id=1bd2f45c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd2f45c",
  null
  
)

export default component.exports